import { createMenuRoleMappingAPI, creteMenuAPI, deleteFeatureAPI, deleteMenuAPI, deleteRoleModuleMappingAPI, featureMenuPagingAPI, featurePagingAPI, menuGetByIdAPI, menuNotInRolesAPI, menuPagingAPI, roleMenuMappingAPI, updateMenuAPI } from "../../../api/url"
import { formatTreeViewData } from "../../../common/commonFunctions"
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, setReducerState, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from "../../../store/store"
import { getLocalStorageItem } from "../../../utils/storageHelper"
import { APICallFunction } from "../role/apiCall"
import { MenuKeys } from "./entity"
const { dispatch } = store

export const getMenuPaging = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: MenuKeys.paging,
        url: menuPagingAPI,
        request: { ..._request, ['ApplicationId']: getLocalStorageItem('ApplicationId') },
    }))
}

export const deleteMenu = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: MenuKeys.delete,
        url: deleteMenuAPI,
        request: { MenuId: _request }
    }))
}

export const getMenuRoleMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: MenuKeys.getRoles,
        url: roleMenuMappingAPI,
        request: { ..._request },
    }))
}

export const deleteMenuRoleMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: MenuKeys.deleteRoles,
        url: deleteRoleModuleMappingAPI,
        request: [_request]
    }))
}

export const getMenuFeatureMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: MenuKeys.getFeatures,
        url: featureMenuPagingAPI,
        request: { ..._request },
    }))
}

export const deleteMenuFeaturesMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: MenuKeys.deleteFeatures,
        url: deleteFeatureAPI,
        request: { FeatureId: _request }
    }))
}

export const createMenuRoleMapping: APICallFunction = async (params) => {
    const { key = MenuKeys.addRoles, request = {}, url = createMenuRoleMappingAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getMenuNotInRoles: APICallFunction = async (params) => {
    const { key = MenuKeys.notInRoles, request = {}, url = menuNotInRolesAPI } = params;
    const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getMenubyId: APICallFunction = async (params) => {
    const { key = MenuKeys.get, request = {}, url = menuGetByIdAPI(request?.id) } = params;
    const res = await dispatch(getByIdAPI({ key: key, url: url }));
    return res?.payload?.value;
}

export const createMenu: APICallFunction = async (params) => {
    const { key = MenuKeys.create, request = {}, url = creteMenuAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateMenu: APICallFunction = async (params) => {
    const { key = MenuKeys.update, request = {}, url = updateMenuAPI(request.id) } = params;
    const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getMenuTree: APICallFunction = async (params) => {
    const { key = MenuKeys.tree, request = {}, url = featureMenuPagingAPI } = params;
    request.MenuId = request.id
    let res = await dispatch(getByBodyAPI({ key: '', url: url, request: request }));
    res = { data: formatTreeViewData(res?.payload?.data, 'ChildName', 'DisplayName') };

    dispatch(setReducerState({ key: key, value: res }));
    return res;
}
